import { Link } from "react-router-dom"

export default function CtaBanner() {
	return (
		<>
			<section className="cta-banner-section section-padding">
				<div className="container">
					<div
						className="cta-banner-wrapper fix bg-cover"
						style={{ backgroundImage: 'url("assets/img/cta-bg.jpg")' }}
					>
						<h2 className="wow fadeInUp" data-wow-delay=".2s">
							Looking for the Perfect Fit{" "} <br />for Your Next  {" "}
							<span>Door Project?</span>
						</h2>
						<div className="cta-img wow fadeInUp" data-wow-delay=".4s">
							<img src="assets/img/CTA.png" alt="img" width="224" height="257" />
							<div className="shape-img">
								<img src="assets/img/cta-shape.png" alt="img" />
							</div>
						</div>
						<Link
							to="/contact"
							className="theme-btn bg-white wow fadeInUp"
							data-wow-delay=".6s"
						>
							contact us
							<i className="fa-regular fa-arrow-right" />
						</Link>
					</div>
				</div>
			</section>
		</>
	)
}
